import styled from 'styled-components';
import { lighten } from "polished";
import { colors } from '../../styles/variables';

const StyledButton = styled.button`
  border-radius: 4px;
  display: block;
  text-align: center;
  transition: 0.2s all ease-in-out;
  border: none;
  min-width: 100px;
  color: ${colors.red};
  background-color: ${colors.white};
  border: ${`1px solid ${colors.red}`};
  padding: 0.5rem 1rem;
  &:hover {
    color: ${colors.red};
    background-color: ${lighten(0.35, colors.red)};
  }
`;

export const Button = ({type, children, ...props}) => {
  return (
    <StyledButton type={type} {...props}>
      {children}
    </StyledButton>
  )
}